module.exports = __webpack_public_path__ + "assets/operator-black.b53cd923.svg";